import { ISearchUserInfo } from '../interface';
import { Application } from 'common/src/services';

interface IDepartmentSearchPageData {
    userInfo: ISearchUserInfo;
    Lang: string;
    SYSTEM: string;
    siteHost: string;
}
class AppService extends Application<IDepartmentSearchPageData> {}
const templateData = Application.getTemplateData();
const data = templateData?.data;
const config = templateData?.config;
const pageData: IDepartmentSearchPageData = {
    userInfo: data?.user_info,
    Lang: config?.lang,
    SYSTEM: config?.system,
    siteHost: config?.site_host,
};

const appService = new AppService(pageData);
const getAppData = appService.getData;
export default appService;
export { getAppData, IDepartmentSearchPageData };
